<script>
/**
 * @Author: zhangxiaojian
 * @Date: 2025/6/25
 * @LastEditors: zhangxiaojian
 * @Description AI对话单条内容
 **/
import MarkdownRenderer from '@components/EditArticleCommon/components/ueditor/components/MarkdownRenderer/index.vue'
import Articles from './Articles.vue'
export default {
  name: 'MessageContent',
  components: {
    MarkdownRenderer,
    Articles
  },
  data() {
    return {
      compiledMarkdown: ''
    }
  },
  emits: [
    /**
     * 重新生成回答
     */
    'reloadAnswer'
  ],
  props: {
    showReload: {
      // 是否显示重新生成按钮
      type: Boolean,
      default: false
    },
    isUser: {
      // 是否是用户
      type: Boolean,
      default: false
    },
    isDone: {
      // 是否回答完成
      type: Boolean,
      default: false
    },
    articles: {
      // 引用的文章列表
      type: Array,
      default: () => []
    },
    content: {
      // 对话内容
      type: String,
      default: ''
    }
  },
  methods: {
    /**
     * 重新回答
     */
    reloadAnswer() {
      this.$emit('reloadAnswer')
    },
    /**
     * 复制内容
     */
    copyContent() {
      let content = this.$refs.markDownContent.compiledMarkdown
      content = content.replace(/<[^>]*>?/gm, '').trim()
      navigator.clipboard
        .writeText(content)
        .then(() => this.$message.success('复制成功'))
        .catch(() => this.$message.error('复制失败'))
    }
  }
}
</script>

<template>
  <div class="message-content">
    <div :class="`message-content-avatar ${isUser ? 'is-myself' : ''}`">
      <img v-if="isUser" src="../../../assets/img/knowledge/user.png" />
      <img v-else src="../../../assets/img/knowledge/icon_ai.png" />
    </div>
    <div :class="`message-content-text ${isUser ? 'is-myself' : ''}`">
      <div v-if="content && isUser" v-html="content"></div>
      <template v-else-if="content">
        <MarkdownRenderer
          :is-done="isDone"
          :content="content"
          ref="markDownContent"
        />
        <div v-if="articles.length > 0">
          <Articles :articles="articles" />
        </div>
      </template>

      <div v-else>
        <i class="el-icon-loading" />&nbsp;
        <span>正在为您生成内容...</span>
      </div>
      <div v-if="isDone" class="message-content-text-operate">
        <div
          v-if="showReload"
          class="message-content-text-reload"
          @click="reloadAnswer"
        >
          <i class="el-icon-refresh" />
          <span>重新生成</span>
        </div>
        <div class="message-content-text-copy" @click="copyContent">
          <i class="el-icon-copy-document" />
          <span>内容复制</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.message-content {
  display: flex;
  margin-bottom: 18px;
  &-avatar {
    img {
      width: 20px;
    }
  }
  &-text {
    background: #fff;
    font-size: 14px;
    position: relative;
    padding: 6px 10px;
    line-height: 2;
    border-radius: 8px;
    margin-left: 10px;
    width: 100%;
    &.is-myself {
      color: #fff;
      width: auto;
      background: #0057b8;
    }
    &-operate {
      display: flex;
      color: #949db7;
      font-size: 12px;
      margin-top: 10px;
      & > div {
        margin-right: 10px;
        cursor: pointer;
        span {
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
